import * as React from 'react';

import { Translate } from '@decorators';

import { MultilineText } from '@common/components/MultilineText';

import { EBrandFileName } from '../../enums';
import { IBrandPageProps } from '../../types';
import { BrandBlock } from '../BrandBlock';

import * as s from './BrandFontsScreen.scss';

@Translate('common.containers.Brand.components.BrandFontsScreen')
export class BrandFontsScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			isMobile,
			brand,
			urls,
			onDownloadButtonClick,
		} = this.props;

		return (
			<div className={s.block}>
				<BrandBlock
					title={'TT Norms'}
					downloadTitle={this.t('download')}
					downloadFileSize={isMobile ? null : brand.fileSizes.logogram.color}
					downloadLinkUrl={`${urls.brandDownload}/${EBrandFileName.FONTS}.zip`}
					classNames={{
						content: s.blockContent,
						title: s.title,
					}}
					onDownloadButtonClick={onDownloadButtonClick}
				>
					<div className={s.subtitle}>
						{'by TypeType'}
					</div>

					<div className={s.description}>
						<MultilineText text={this.t('description')}/>
					</div>

					<div className={s.chars}>
						{this.t('alphabet')
							.split('')
							.map((char) => (
								<div key={char} className={s.char}>
									{char.toUpperCase()}
									{char}
								</div>
							))
						}
					</div>

					<div className={s.description}>
						<MultilineText text={this.t('platformDescription')}/>
					</div>

					<div className={s.table}>
						<div className={s.platforms}>
							<div className={s.tableHeader}>
								{this.t('platform')}
							</div>
							<div className={s.platform}>
								{'Web'}
							</div>
							<div className={s.platform}>
								{'iOS'}
							</div>
							<div className={s.platform}>
								{'Android'}
							</div>
							<div className={s.platform}>
								{'Print'}
							</div>
						</div>

						<div className={s.headings}>
							<div className={s.tableHeader}>
								{this.t('headings')}
							</div>
							<div className={s.heading}>
								{'TT Norms Pro Bold'}
							</div>
							<div className={s.heading}>
								{'TT Norms Pro Bold'}
							</div>
							<div className={s.heading}>
								{'TT Norms Pro Bold'}
							</div>
							<div className={s.heading}>
								{'TT Norms Pro Bold'}
							</div>
						</div>

						<div className={s.typefaces}>
							<div className={s.tableHeader}>
								{this.t('typeface')}
							</div>
							<div className={s.typeface}>
								{this.t('systemFont')}
							</div>
							<div className={s.typeface}>
								{'SF Pro Display/Text'}
							</div>
							<div className={s.typeface}>
								{'Roboto'}
							</div>
							<div className={s.typeface}>
								{'TT Norms'}
							</div>
						</div>
					</div>
				</BrandBlock>
			</div>
		);
	}

}
